import React from "react";
import styled from "styled-components";

import { NextBrainHealthCheckin } from "components/simple";
import ScoreHistoryChart from "components/simple/ScoreHistoryChart";
import { mapScoreHistory } from "utils/mapScoreHistory";
import { color, fontFamily, fontSize, spacingDefaults } from "style/constants";

import PulseHeader from "./PulseHeader";

export interface PulseLandingLayoutProps {
  score: number;
  nextPulseDate: string;
  currentDay: number;
  totalDays: number;
  pulsesCompleted: number;
  ctaEnabled: boolean;
  onTakePulse: () => void;
  scoreHistory: Array<{ pulseIndex: number; calculatedAt: string }>;
}

const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentCard = styled.div`
  display: flex;
  width: 51.125rem;
  max-width: 90%;
  padding: 1.875rem 1.0625rem;
  flex-direction: column;
  align-items: center;
  gap: 2.25rem;
  border-radius: 0.18263rem;
  border: 0.731px solid #c8c8c8;
  background: ${color.WHITE};
  box-shadow: 0 1.461px 8.767px 0 rgba(0, 0, 0, 0.1);
`;

const SectionLabel = styled.h2`
  font-family: ${fontFamily.primary};
  font-size: ${fontSize.normal};
  font-weight: 700;
  color: ${color.BLACK};
  margin: 0;
  text-align: center;
`;

const Footnote = styled.p`
  font-family: ${fontFamily.primary};
  font-size: ${fontSize.small};
  color: ${color.DARKERGRAY};
  text-align: center;
  margin: 0;
  max-width: 500px;
`;

const PulseLandingLayout: React.FC<PulseLandingLayoutProps> = ({
  score,
  nextPulseDate,
  currentDay,
  totalDays,
  pulsesCompleted,
  ctaEnabled,
  onTakePulse,
  scoreHistory
}) => {
  const points = mapScoreHistory(scoreHistory);

  return (
    <PageWrapper data-testid="pulse-landing-layout">
      <PulseHeader score={score} />
      <ContentCard>
        <SectionLabel>Your Progress</SectionLabel>

        <NextBrainHealthCheckin
          nextPulseDate={nextPulseDate}
          currentDay={currentDay}
          totalDays={totalDays}
          pulsesCompleted={pulsesCompleted}
          onTakePulse={ctaEnabled ? onTakePulse : () => {}}
        />

        <ScoreHistoryChart points={points} />

        <Footnote data-testid="pulse-footnote">
          Your Pulse score is a snapshot of your overall brain health - think of
          it like a vital sign. Higher scores indicate stronger performance.
          Taking the Pulse more than once can help you track changes.
        </Footnote>
      </ContentCard>
    </PageWrapper>
  );
};

export default PulseLandingLayout;
